import NotificationManagementModal from './notification-management-modal';

export default NotificationManagementModal;